/* eslint-disable no-new */
import { RequestHelp_Banner } from './RequestHelp_Banner';
import { RequestHelp_Util } from './RequestHelp_Util';
import { Window } from '../../../00_IMMEDIATE/Window';
import { Window_FillRateFallback } from '../Window_FillRateFallback';
import OMT_UI_SquareButton, { BUTTONCOLOURS } from '../../../OMT_UI/OMT_UI_SquareButton';
import RequestHelp_Wheel from './RequestHelp_Wheel';
import OMT_UI_DrawUtil from '../../../OMT_UI/Drawing/OMT_UI_DrawUtil';

/**
 * Some functions are being used from Window_requestHelp.js
 * @author Sandra Koo
 *
 * rhm = RequestHelpMessage
 * rh = RequestHelp
 */
export class requestHelpMessage extends Window {
  constructor(parent, requestHelpParams) {
    super(parent);

    this.prizeText = {
      style: 'font-num-blue',
      fontSize: 60,
      scaleStroke: true,
      align: 'center',
      lineSpacing: -10,
    };

    this.prizeList = this.initPrize(); // Prize!?

    this.isWatchingAd = false; // Prevents buttons from working here

    this.rhm_wheel = new RequestHelp_Wheel({ // The Wheeeeeel
      prizeList: this.prizeList,
      isFirstTimeSpinning: false,
      autoStart: true,
      deadSpot: false,
      fromHelpers: requestHelpParams.fromHelpers,
    });
    this.rhm_wheel.fillWheel();
    this.rhm_wheel.signals.collectWheelPrizeVisually.add(() => {
      this.collectWheelPrizeVisually(this.prizeList);
    });

    this.rhm_prizePack = this.prizeScreenInit(); // Draws prize screen, rhm style
    this.rhm_banner = new RequestHelp_Banner({
      text: OMT.language.getText('Booster Wheel'),
      bannerImg: 'green_wheel_ribbon',
    });
    this.rhm_banner.y = -275;
    this.rhm_prizePack.display.visible = false;

    this.addChild(this.rhm_wheel);
    this.addChild(this.rhm_banner);

    this.enterTheWheel(); // Enter the wheel
    RequestHelp_Util.enterTheBanner(this.rhm_banner); // And the banner fro Window_requestHelp
  }

  /**
   * Inits the prize list and swaps out whatever is needed
   */
  initPrize() {
    const theList = G.gift.getRequestHelpMessengerGifts();
    const currentPrizes = RequestHelp_Util.copyPrizeData(theList);

    for (let i = 0; i < currentPrizes.length; i++) {
      const curPrize = currentPrizes[i];
      let getBooster = curPrize.prize === 'booster'; // Is it just a selection booster?
      if (curPrize.prize === 'prebooster') { // Or prelevel?
        const preBoosters = G.gift.getAvailablePreLevelBoosters(); // Is there any prelevel boosters you can get?
        if (preBoosters.length > 0) {
          const rng = game.math.between(0, preBoosters.length - 1);
          const chosenBooster = preBoosters[rng];

          curPrize.prize = chosenBooster;

          continue; // Stop here and resume loop
        } else { // No there wasn't any... just get a selection booster instead
          getBooster = true;
          // Flow through down
        }
      }

      if (getBooster) { // A selection booster?
        const booster = G.gift.getAvailableInGameBoosters();
        if (booster.length > 0) { // Can you get any?
          const rng = game.math.between(0, booster.length - 1);
          const chosenBooster = booster[rng];

          curPrize.prize = chosenBooster;
        } else {
          curPrize.prize = 'booster#1'; // Just take it...
        }
      }
    }

    return { // No swapping of prizes, no need for base
      current: currentPrizes,
      predeterminedPrize: -1,
    };
  }

  /**
   * Draw the init screen
   */
  prizeScreenInit() {
    const mainDisplay = new Phaser.Group(G.game, this);

    const prizeScreen = new Phaser.Group(G.game, null);
    const shine1 = G.makeImage(0, 0, 'shine_godrays', 0.5);
    shine1.update = () => {
      shine1.angle += 0.01;
      if (shine1.angle === 360) { shine1.angle = 0; }
    };

    prizeScreen.addChild(shine1);
    mainDisplay.addChild(prizeScreen);

    const watchAdBtn = new Phaser.Group(G.Game, null); // The watch ad button
    if (OMT.feature.rewardedAdsAvailable()) {
      const videoImg = G.makeImage(0, 0, 'btn-movie-icon', 0.5, null);
      const actualWatchAdBtn = new OMT_UI_SquareButton(0, 0, {
        button: {
          tint: BUTTONCOLOURS.purple,
          dimensions: {
            width: 309,
            height: 100,
          },
          extraDetail: false,
        },
        text: {
          string: OMT.language.getText('Try again'),
          textStyle: 'font-white',
          icon: {
            image: videoImg,
            offset: {
              x: videoImg.width / 4,
            },
            align: 'left',
          },
          offset: {
            x: -videoImg.width / 4,
          },
        },
        options: {
          clickFunction: {
            onClick: this.watchAdClicked.bind(this),
          },
        },
      });
      watchAdBtn.addChild(actualWatchAdBtn);
    }

    // Claim reward button
    const onClick = () => {
      if (this.isWatchingAd) { return; } // Don't do anything if we're watching
      const chosenPrize = this.prizeList.current[this.prizeList.predeterminedPrize]; // Pick the prize
      OMT.transactionTracking.logInventoryTransactionBegin();

      if (chosenPrize.prize.indexOf('coin') > -1) { // Is coin?
        watchAdBtn.onChildInputDown.removeAll();

        this.state.uiTargetParticles.createCoinBatch( // Particles
          game.world.bounds.x + this.rhm_prizePack.prizeScreen.worldPosition.x,
          this.rhm_prizePack.prizeScreen.worldPosition.y,
          this.state.panel.coinsTxt,
          chosenPrize.amount,
          true,
        );

        OMT.transactionTracking.addInventoryChange('coins', 0, chosenPrize.amount);

        game.time.events.add(500, () => { // Wait for animation then close
          this.closeWindow();
        }, this);
      } else {
        G.gift.applyGift([chosenPrize.prize, chosenPrize.amount], false); // Get booster
        this.closeWindow();
      }

      OMT.transactionTracking.logInventoryTransactionEnd();
      DDNA.transactionHelper.trackRewards([chosenPrize.prize, chosenPrize.amount], [], {
        transactionType: 'REWARD', tActionType: 'REQUEST_HELP_USE', tGameArea: 'MAP',
      });
    };
    const claimRewardBtn = new OMT_UI_SquareButton(0, 0, {
      button: {
        tint: BUTTONCOLOURS.green,
        dimensions: {
          width: 309,
          height: 100,
        },
      },
      text: {
        string: OMT.language.getText('Claim'),
        textStyle: { style: 'font-white', fontSize: 70 },
      },
      options: {
        clickFunction: {
          onClick: onClick.bind(this),
          disableAfterClick: true,
        },
      },
    });
    watchAdBtn.y = 250 + watchAdBtn.height / 2; // Position
    claimRewardBtn.y = watchAdBtn.y + watchAdBtn.height + (claimRewardBtn.height / 2) + 40;

    claimRewardBtn.originalY = claimRewardBtn.y; // Keep track of these...
    watchAdBtn.originalY = watchAdBtn.y;

    mainDisplay.addChild(claimRewardBtn);
    mainDisplay.addChild(watchAdBtn);

    return {
      display: mainDisplay,
      prizeScreen,
      prize: null, // Phaser.Group, to be set later
      claimRewardBtn,
      watchAdBtn,
    };
  }

  /**
   * Plays tween for the wheel to enter
   */
  enterTheWheel() {
    let goodbyePrize; // Tweens outside so I can access
    let alphaPrize2;
    let goodbyeTryAgain;
    if (this.rhm_prizePack.display.visible) { // If the prize screen is here, make it go away
      this.rhm_prizePack.prizeScreen.scale.x = this.rhm_prizePack.prizeScreen.scale.y = 1;
      this.rhm_prizePack.prizeScreen.alpha = 1;
      const targetClaimY = this.rhm_prizePack.claimRewardBtn.originalY + 500;
      const targetVideoY = this.rhm_prizePack.watchAdBtn.originalY + 500;

      goodbyePrize = game.add.tween(this.rhm_prizePack.prizeScreen.scale)
        .to({ x: 0.01, y: 0.01 }, 200, Phaser.Easing.Sinusoidal.InOut, false);
      alphaPrize2 = game.add.tween(this.rhm_prizePack.prizeScreen)
        .to({ alpha: 0 }, 200, Phaser.Easing.Sinusoidal.InOut, false);
      const goodbyeClaim = game.add.tween(this.rhm_prizePack.claimRewardBtn)
        .to({ y: targetClaimY, alpha: 0 }, 200, Phaser.Easing.Sinusoidal.InOut);
      goodbyeTryAgain = game.add.tween(this.rhm_prizePack.watchAdBtn)
        .to({ y: targetVideoY, alpha: 0 }, 200, Phaser.Easing.Sinusoidal.InOut);

      goodbyePrize.chain(goodbyeClaim);
      goodbyeClaim.chain(goodbyeTryAgain);
    }

    // Apply wheel
    this.rhm_wheel.container.scale.x = this.rhm_wheel.container.scale.y = 0.01;

    // Tween
    if (goodbyePrize) { // If the prize is tweening out
      goodbyeTryAgain.onComplete.addOnce(function () {
        this.rhm_prizePack.display.visible = false;
        this.isWatchingAd = false; // Not watching anymore! In case you might have been
        this.rhm_wheel.enterTheWheel();
      }, this);

      goodbyePrize.start(); // Tween out
      alphaPrize2.start();
    } else { // Or just start
      this.rhm_wheel.enterTheWheel();
    }
  }

  /**
   * Get the prize! Mostly similar to Window_requestHelp.rh_collectWheelPrizeVisually
   * @param {Object} prizeList
   */
  collectWheelPrizeVisually(prizeList) {
    if (this.rhm_prizePack.prize) { // Take out the old prize list
      const oldPrize = this.rhm_prizePack.prize;
      this.rhm_prizePack.prizeScreen.removeChild(oldPrize);
      oldPrize.destroy(true);
    }

    const chosenPrize = prizeList.current[prizeList.predeterminedPrize];
    let giftString = OMT_UI_DrawUtil.getGiftString(chosenPrize.prize);
    const isCoin = giftString.indexOf('coin') > -1;
    if (isCoin) { giftString = giftString.replace('_1', '_3'); } // "coin_3", I don't want to modify the giftString func for this 2nd case
    // Avoid getting the pixely picture by using the bigger one, "coin_3"

    const prize = new Phaser.Group(G.Game, null);
    const giftImage = G.makeImage(0, 0, giftString, 0.5, null);
    giftImage.width = giftImage.height = 200;
    if (isCoin) { // Add text if coin
      const giftText = new G.Text(0, 0, chosenPrize.amount, this.prizeText, 0);
      giftText.x = 0 - giftText.width / 2;
      giftText.y = giftImage.y + giftImage.height / 2;

      prize.addChild(giftText);
    }
    prize.addChild(giftImage);
    this.rhm_prizePack.prizeScreen.addChild(prize);
    this.rhm_prizePack.prize = prize;

    // Setup properties of graphics
    this.rhm_prizePack.display.visible = false;
    this.rhm_prizePack.prizeScreen.scale.x = this.rhm_prizePack.prizeScreen.scale.y = 0.01;
    this.rhm_wheel.container.scale.x = this.rhm_wheel.container.scale.y = 1;
    this.rhm_prizePack.watchAdBtn.alpha = this.rhm_prizePack.claimRewardBtn.alpha = 0;

    const originalClaimY = this.rhm_prizePack.claimRewardBtn.originalY;
    const originalVideoY = this.rhm_prizePack.watchAdBtn.originalY;
    this.rhm_prizePack.claimRewardBtn.y = this.rhm_prizePack.claimRewardBtn.originalY + 500;
    this.rhm_prizePack.watchAdBtn.y = this.rhm_prizePack.claimRewardBtn.originalY + 500;

    // Tween
    const goodbyeWheel = game.add.tween(this.rhm_wheel.container.scale)
      .to({ x: 0.01, y: 0.01 }, 200, Phaser.Easing.Custom.SoftBounce);

    const comeInPrize = game.add.tween(this.rhm_prizePack.prizeScreen.scale)
      .to({ x: 1, y: 1 }, 200, Phaser.Easing.Sinusoidal.InOut, false);
    const alphaPrize = game.add.tween(this.rhm_prizePack.prizeScreen)
      .to({ alpha: 1 }, 200, Phaser.Easing.Sinusoidal.InOut, false);

    const comeClaim = game.add.tween(this.rhm_prizePack.claimRewardBtn)
      .to({ y: originalClaimY, alpha: 1 }, 200, Phaser.Easing.Sinusoidal.InOut);
    const comeTryAgain = game.add.tween(this.rhm_prizePack.watchAdBtn)
      .to({ y: originalVideoY, alpha: 1 }, 200, Phaser.Easing.Sinusoidal.InOut);

    goodbyeWheel.onComplete.add(() => { // When the wheel is gone, the rest can come in
      this.rhm_wheel.container.visible = false;
      this.rhm_prizePack.display.visible = true;
      alphaPrize.start();
      comeInPrize.start();
    });
    comeInPrize.chain(comeTryAgain);
    comeTryAgain.chain(comeClaim);
    goodbyeWheel.start();
  }

  /**
   * Event that happens when the watch ad is clicked
   */
  watchAdClicked() {
    if (this.isWatchingAd) { return; } // Don't double click

    this.isWatchingAd = true; // Its on

    G.sb('fillRateFallbackClosed').addOnce(this.onAdGiveUp, this); // In case they press the X button, the buttons must turn back on

    OMT.ads.showAd( // Show the ad
      G.BuildEnvironment.adPlacements.requestMoveHelpWheelSpin,
      this.onAdSuccess.bind(this),
      () => {
        if (!G.IAP) { // no IAPS dont use ad fallbacks
          new Window_FillRateFallback(undefined, {
            placement: G.BuildEnvironment.adPlacements.spinTheDailyWheel,
            trackingName: 'requestHelpAdFail',
            callback: this.onAdSuccess.bind(this),
            context: this,
          });
        } else { // ad fallback
          this.isWatchingAd = false;
          OMT.ads.showAdFallback(this.onAdSuccess.bind(this));
        }
      },
    );
  }

  /**
   * When the ad is successfully watched
   */
  onAdSuccess() {
    this.enterTheWheel(); // enterTheWheel will turn off isWatchingAd
  }

  /**
   * When they give up :(
   */
  onAdGiveUp() {
    if (this.game) {
      this.isWatchingAd = false;
    } else {
      G.sb('fillRateFallbackClosed').remove(this.onAdGiveUp, this);
    }
  }
}

// create global references
if (!window.Windows) window.Windows = {};
Windows.requestHelpMessage = requestHelpMessage;
